const initialState = {
    arr: []
}

const passportUpladRed = (state = initialState, action) => {
    switch(action.type){
        case 'PASSPORT_UPLOAD' : {
            return {
                ...state,
                arr: action.arr
            }
        }
        default: {
            return state
        }
    }
}

export default passportUpladRed